import FindQuestion from '../components/ContactUs/FindQuestion'
import FAQsSection from '../components/FAQ/FAQSection'

const FAQs = () => {
  return (
    <>
    <FAQsSection/>
    <FindQuestion/>
    <div className='sm:pt-40 pt-24'/>
    </>
  )
}

export default FAQs